import { useEffect, useState } from "react";
import { DashboardStats } from "./DashboardStats";

// Version is the shape returned by GET /version on the Go backend.
interface Version {
  version: string;
  commit: string;
  buildDate: string;
}

// DashboardPage is the programme-overview page: build/version info and the
// spec §8 dashboard stats. It used to also show a hand-maintained delivery
// milestone tracker (spec §28's M1-M11 list) — removed once all milestones
// had shipped and the list stopped being useful, since it wasn't derived
// from anything the backend reports and could only ever drift.
export function DashboardPage({ token }: { token: string }) {
  const [version, setVersion] = useState<Version | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch("/version")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json() as Promise<Version>;
      })
      .then(setVersion)
      .catch((e: unknown) => setError(e instanceof Error ? e.message : "unknown error"));
  }, []);

  return (
    <>
      <DashboardStats token={token} />

      <section className="panel status">
        <h2>Service</h2>
        <dl className="build">
          <div>
            <dt>Version</dt>
            <dd>{version?.version ?? (error ? "—" : "…")}</dd>
          </div>
          <div>
            <dt>Commit</dt>
            <dd className="mono">{version?.commit ?? (error ? "—" : "…")}</dd>
          </div>
          <div>
            <dt>Built</dt>
            <dd className="mono">{version?.buildDate ?? (error ? "—" : "…")}</dd>
          </div>
        </dl>
        {error && <p className="err">Could not reach /version: {error}</p>}
      </section>
    </>
  );
}
